module.exports = __webpack_public_path__ + "static/img/pepper.e6c05a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/pepper.png
// module id = 95P7
// module chunks = 6